import './Image.scss';

import React from 'react';

export default class Image extends React.Component {
  constructor() {
    super();
    this.state = {
      failed: false
    };
  }

    fallback = () => {
      const { fallbackSrc } = this.props;
      if (fallbackSrc) {
        this.setState({ failed: true });
      }
    };
    render() {
      const { failed } = this.state;
      const { fallbackSrc, alt, src, className } = this.props;
      if (failed || !src) {
        return <img src={fallbackSrc} alt={alt} className={className ? className : ''} />;
      } else {
        return <img src={src} alt={alt} onError={this.fallback} className={className ? className : ''} />;
      }
    }
}